"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithTitle = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const useStyles = styles_1.makeStyles(theme => ({
    title: {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
}));
const IconWithTitle = ({ icon, title, }) => {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { display: 'flex', flexDirection: 'row' },
        icon,
        react_1.default.createElement(core_1.Typography, { variant: 'h6', className: classes.title }, title)));
};
exports.IconWithTitle = IconWithTitle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbldpdGhUaXRsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0ljb25XaXRoVGl0bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUE2QztBQUM3Qyw0Q0FBb0Q7QUFDcEQscURBQXNEO0FBT3RELE1BQU0sU0FBUyxHQUFHLG1CQUFVLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3JDLEtBQUssRUFBRTtRQUNMLFVBQVUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztRQUM1QixZQUFZLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7S0FDL0I7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVHLE1BQU0sYUFBYSxHQUEyQixDQUFDLEVBQ3BELElBQUksRUFDSixLQUFLLEdBQ2MsRUFBRSxFQUFFO0lBQ3ZCLE1BQU0sT0FBTyxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBQzVCLE9BQU8sQ0FDTCw4QkFBQyxVQUFHLElBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRSxhQUFhLEVBQUUsS0FBSztRQUN2QyxJQUFJO1FBQ0wsOEJBQUMsaUJBQVUsSUFBQyxPQUFPLEVBQUMsSUFBSSxFQUFDLFNBQVMsRUFBRSxPQUFPLENBQUMsS0FBSyxJQUM5QyxLQUFLLENBQ0ssQ0FDVCxDQUNQLENBQUM7QUFDSixDQUFDLENBQUM7QUFiVyxRQUFBLGFBQWEsaUJBYXhCIn0=